import { useState } from 'react'
import './GenericPopup.css'

type PopupButton = {
  text: string,
  callback: () => void
}

interface GenericPopupProps {
  popupImage?: string,
  title: string,
  description?: string,
  buttonText: string,
  extraButtons?: PopupButton[]
  callback: () => void
  callbackDelay?: number
}

export default function GenericPopup ({ callbackDelay = 1000, ...props }: GenericPopupProps) {
  const extraButtons: JSX.Element[] = []
  const [animationClass, setAnimationClass] = useState(['animation-fadeIn', 'animation-popup-enter'])

  if (props.extraButtons !== undefined) {
    props.extraButtons.forEach((button, index) => {
      extraButtons.push((
        <button key={index} className='btn_long--blank' onClick={button.callback}>{button.text}</button>))
    })
  }

  function handleButtonClick () {
    setAnimationClass(['animation-fadeOut', 'animation-popup-leave'])
    setTimeout(() => {
      props.callback()
    }, props.callbackDelay)
  }

  return (
    <div className='w-full h-full top-0 left-0 absolute grid content-center'>
      <div className={'absolute inset-0 bg-primary-darkTransparent ' + animationClass[0]}></div>
      <div
        className={'relative mx-auto w-[334px] bg-primary-white text-center rounded-[24px] flex item-center p-[15px] ' +
          animationClass[1]}>
        <div className={'flex flex-col'}>
          <div className={'w-full relative' + (props.popupImage ? ' translate-y-[-60px]' : '')}>
            {props.popupImage && <img src={props.popupImage} className='object-contain mx-auto' />}
            <p className='text-2xl text-primary-blue font-bold'>{props.title}</p>
            {props.description && <p className='my-[10px]'>{props.description}</p>}
          </div>
          <div>
            <button className='btn_long--blue' onClick={handleButtonClick}>{props.buttonText}</button>
            {extraButtons}
          </div>
        </div>
      </div>
    </div>
  )
}
